import { gql } from '@apollo/client';

export const CREATE_PDP_SEARCH_SUGGESTION_MAIL = gql`
    mutation CreatePdpSearchSuggestionMail($pdpSearchSuggestionInput: PdpSearchSuggestionInput!) {
        createPdpSearchSuggestionMail(pdpSearchSuggestionInput: $pdpSearchSuggestionInput)
    }
`;
